// Tolerance status colors
export const TOLERANCE_COLORS = {
    IN: '#48bb78', // Green for within 75% tolerance
    WARNING: '#ff8c00', // Orange for 75-100% tolerance
    OUT: '#ef4444', // Red for out of tolerance
    CORRECT: '#48bb78' // Green for correct answer on no measurement tools (ok, nok)
} as const;
